import React from 'react';
import './LoginView.css'

export const LoginContainer = props => {

    return (<div id="loginContainer">
        {props.children}
    </div>);

}
